module.exports = __webpack_public_path__ + "static/media/d534cd06-5c8e-4264-bc8d-b0ee788dca35_1.14bd0343a74dc384c3b58cc6bb662f03.0347878d.jpeg";